/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class EnrolmentYearLevelRoute extends Route {
  // Services
  @service
  schoolSchema;

  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return hash({
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
      genderField: this.schoolSchema.getLearnerGenderField(),
    });
  }
}
